type Isolation = { users: number; observer: MutationObserver; original: Map<HTMLElement, boolean> };
const documents = new WeakMap<Document, Isolation>();

export function retainNativeModalIsolation(document: Document): () => void {
  let isolation = documents.get(document);
  if (!isolation) {
    const original = new Map<HTMLElement, boolean>();
    const sync = () => {
      const hidden = new Set(Array.from(document.querySelectorAll<HTMLElement>('[aria-hidden="true"]')).filter(
        (element) => element instanceof HTMLElement && element.closest('[data-base-ui-inert]') && !element.hasAttribute('data-base-ui-focus-guard'),
      ));
      for (const [element, previous] of original) {
        if (hidden.has(element)) continue;
        element.inert = previous;
        original.delete(element);
      }
      for (const element of hidden) {
        if (!original.has(element)) original.set(element, element.inert);
        element.inert = true;
      }
    };
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'data-base-ui-inert'] });
    isolation = { users: 0, observer, original };
    documents.set(document, isolation);
    sync();
  }
  const retained = isolation;
  retained.users += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--retained.users) return;
    retained.observer.disconnect();
    for (const [element, previous] of retained.original) element.inert = previous;
    retained.original.clear();
    documents.delete(document);
  };
}
